export enum SCREEN_SIZE {
	MOBILE = 480,
	TABLET = 768,
	DESKTOP = 1280,
}